export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_8-ab2ee2ef062a70c18baebe3f8bd3e3f4.svg";